import React, {useState, useEffect, Fragment} from 'react'
import {useDispatch, useSelector} from "react-redux"

// Material-UI Core
import {makeStyles} from '@material-ui/core/styles'

// Material-UI Lab
// import Fab from '@material-ui/core/Fab'

// Material-UI Icon
// import MenuBookIcon from '@material-ui/icons/MenuBook'

// Custom Component
import useLoading from "../Loading/useLoading"
import TabMenu from "../TabMenu/TabMenu"
import CurrentDrawings from "./CurrentDrawings"
import Covers from "./Covers"
import CreateDrawing from "./CreateDrawing"

// Custom Style
import drawingRegisterStyle from '../../styles/jss/components/drawingRegister/drawingRegisterStyle'

// Fetch Data


const useStyles = makeStyles(theme => drawingRegisterStyle(theme))

const DrawingRegister = props => {
	const store = require('store')
	const classes = useStyles()

	store.set('annotActive', false)

	const [annotSaveChangeAction, setAnnotSaveChangeAction] = useState(null)

	const tabMenuProperty = [
		{
			tabIndex: 0,
			name: "Current Drawings",
			form: <CurrentDrawings
					annotSaveChangeAction={annotSaveChangeAction}
					setAnnotSaveChangeAction={setAnnotSaveChangeAction}
				/>
		},
		{
			tabIndex: 1,
			name: "Covers",
			form: <Covers
					annotSaveChangeAction={annotSaveChangeAction}
					setAnnotSaveChangeAction={setAnnotSaveChangeAction}
				/>
		},
		{
			tabIndex: 2,
			name: "Create Drawing",
			form: <CreateDrawing />
		},
	]


	useEffect(() => {
	}, [])


	return (
		// console.log("File List | Variable: fileList (FileManager.js)"),
		// console.log(fileList),

		// console.log("---------------------------------------------------------------------------------"),


		<Fragment>
			<TabMenu
				type = "primary"
				property = {tabMenuProperty}
				defaultTabValue = {0}
			/>
		</Fragment>
	)
}


export default DrawingRegister